import { FC, useMemo } from 'react';
import cx from 'classnames';
import { Link, useLocation, useMatch, useResolvedPath } from 'react-router-dom';

import { SvgIcon } from '@/components';
import { SubmenuType } from '@/config/navigationPages';

import { checkSubMenuActive } from './SidebarNavSubmenuLink.helpers';
import SubmenuItem from './components/SubmenuItem';

import styles from './SidebarNavSubmenuLink.module.sass';

interface SidebarNavSubmenuLinkProps {
  iconName?: string;
  text: string;
  to: string;
  subMenu: SubmenuType[];
  className?: string;
}

const SidebarNavSubmenuLink: FC<SidebarNavSubmenuLinkProps> = ({
  iconName,
  text,
  to,
  subMenu,
  className,
}) => {
  const location = useLocation();
  const resolved = useResolvedPath(to);
  const mainMatch = useMatch({ path: resolved.pathname, end: true });

  const isSubMenuActive = useMemo(
    () => checkSubMenuActive(subMenu, location.pathname),
    [subMenu, location.pathname],
  );

  const isActive = !!mainMatch || isSubMenuActive;

  const subMenuList = subMenu?.map((item) => (
    <SubmenuItem
      key={item.path}
      item={item}
      locationPathname={location.pathname}
    />
  ));

  const classes = cx(
    styles.link,
    {
      [styles['is-active']]: isActive,
    },
    className,
  );

  return (
    <>
      <Link className={classes} to={to}>
        {iconName && <SvgIcon name={iconName} className={styles.icon} />}
        <span className={styles.text}>{text}</span>
      </Link>

      {isActive && subMenuList?.[0]?.props?.item?.i18NameKey && (
        <div className={styles.submenu}>{subMenuList}</div>
      )}
    </>
  );
};

export default SidebarNavSubmenuLink;
